import type { DragEvent } from "react";
import { useState } from "react";

export function useDragAndDrop(dropCallback: (dataTransfer: DataTransfer) => void) {
  const [isDragging, setIsDragging] = useState(false);

  const onDragOver = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const onDragLeave = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const onDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    dropCallback(e.dataTransfer);
  };
  return { onDragLeave, onDragOver, onDrop, isDragging };
}
